import { render } from "./EditPart.vue?vue&type=template&id=1622628b"
import script from "./EditPart.vue?vue&type=script&lang=js"
export * from "./EditPart.vue?vue&type=script&lang=js"
script.render = render

export default script